import { useState,useEffect } from 'react';
import { createBrowserRouter, RouterProvider, Outlet } from 'react-router-dom';

import { useDispatch } from 'react-redux';

import ChamUpload from './components/ChamUpload/ChamUpload';
import LoadingScreen from './components/LoadingScreen/LoadingScreen';
import LoadingPage from './components/LoadingPage/LoadingPage';
import PatternsPage from './components/PatternsPage/PatternsPage';
import VisualizerPage from './components/VisualizerPage/VisualizerPage';
import ViewInRoomPage from './components/RoomViewPage/RoomViewPage';

import { visualizerActions } from './store';
import { getAllSheetsFromFile } from './Helpers/SheetsHelper';
import { jsonHelper } from './Helpers/JsonHelper';

function Layout() {
  return (
    <>
      <Outlet />
      <ChamUpload />
      <LoadingScreen />
    </>
  );
}

const router = createBrowserRouter([
  {
    element: <Layout />,
    errorElement: <><h1>ERROR</h1></>,
    children: [
      { path: '/', element: <PatternsPage/> },
      { path: '/shared/:code/:spec', element: <LoadingPage/> },
      { path: '/visualizer', element: <VisualizerPage/> },
      { path: '/visualizer/pattern/:patternId/products/:productIds', element: <VisualizerPage/> },
      { path: '/roomview/:spec', element: <ViewInRoomPage/> },
      { path: '/roomview/:spec/selection/:selection', element: <ViewInRoomPage/> },
    ]
  }
])


function App() {
  const [dataReady, setDataReady] = useState(false);
  const dispatch = useDispatch();

  useEffect(() => {
    fetch('https://lizard.chameleonpower.com/CDN/ProductsBySeries/9695.json')
      .then(response => response.json())
      .then(jsonData => {
        dispatch(visualizerActions.setPatternData(jsonData));
      })
      .catch(error => {
        console.error('Error loading pattern data:', error);
      });

    jsonHelper('9696').then(jsonData => {
      dispatch(visualizerActions.setProductDataBySeriesId({ data: jsonData, seriesId: '9696' }));
      setDataReady(true);
    });

    jsonHelper('8615').then(jsonData => {
      dispatch(visualizerActions.setProductDataBySeriesId({ data: jsonData, seriesId: '8615' }));
      setDataReady(true);
    });

    jsonHelper('8069').then(jsonData => {
      dispatch(visualizerActions.setProductDataBySeriesId({ data: jsonData, seriesId: '8069' }));
      setDataReady(true);
    });
   


  }, [dispatch]);

  return (
    <>
      {dataReady && <RouterProvider router={router} />}
      <ChamUpload/>
    </>
  );
}


export default App;


